export const baseData = {
  title: "PRICE LEVEL VENDOR"
}